import * as React from 'react';

import { Page } from '@packages/common';

export interface PageContextValue {
  pageType: Page;
}

export const PageContext = React.createContext({} as PageContextValue);

export interface PageProviderProps {
  page: Page;
}

export const PageProvider: React.FC<PageProviderProps> = ({ page, children }) => {
  return <PageContext.Provider value={{ pageType: page }}>{children} </PageContext.Provider>;
};
